import CardLayout from "../common/CardLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import NoDataAlert from "../common/returns/NoDataAlert";
import LineChartProduto from "./LineChartProduto";

export default function GraficosProdutos({produtos}) {
    
    
    return (
        <div className="flex flex-col gap-4">

            {
                produtos.map((produto) => (
                        <CardLayout key={produto.id}>
                        <Accordion
                            type="single"
                            defaultValue={`item-${produto.id}`}
                            collapsible={true}
                        >
                            <AccordionItem
                                value={`item-${produto.id}`}
                            >
                                <div className="font-semibold">
                                    <AccordionTrigger>
                                        <div className="w-full flex items-center justify-center text-sm lg:text-2xl drop-shadow-1xl">
                                            {produto &&
                                                <div
                                                    className={`uppercase`}
                                                >
                                                    <p>
                                                        <span className="capitalize">
                                                            {
                                                                produto.nome
                                                            }
                                                        </span>
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </AccordionTrigger>
                                </div>
                                <AccordionContent>
                                    <div className="flex flex-col lg:flex-row gap-4 px-4">
                                        {
                                            produto.leiturasProdutos.length === 0 ?
                                                <div className="flex flex-col gap-4 justify-center w-full items-center" key={produto.id}>
                                                    <div className="w-[300px]">
                                                        <NoDataAlert />
                                                    </div>
                                                </div>
                                                :
                                                <div className="flex flex-col lg:flex-row justify-center items-center w-full px-2" key={produto.id}>
                                                    <div className="flex flex-col items-center w-full h-full lg:w-full 2xl:3/4">
                                                        <LineChartProduto chartDataProps={produto} />
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    </CardLayout>
                ))
            }
        </div>
    )
}